// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Опитування» (Surveys, ключ `srv`, група `relationship-management`). */
export const surveysManifest: IModuleManifest = {
  key: 'srv',
  group: 'relationship-management',
  slug: 'surveys',
  prefix: 'SRV',
  name: { en: 'Surveys', uk: 'Опитування' },
  entities: [
    { key: 'srv', slug: 'srv', name: { en: 'Surveys', uk: 'Опитування' }, main: true },
    { key: 'survey_question', slug: 'survey-question', name: { en: 'Survey Questions', uk: 'Запитання' }, main: false },
    { key: 'survey_response', slug: 'survey-response', name: { en: 'Survey Responses', uk: 'Відповіді' }, main: false },
    { key: 'survey_result', slug: 'survey-result', name: { en: 'Survey Results', uk: 'Результати' }, main: false },
  ],
  loadState: () => import('./state/surveysSlice').then((m) => m.surveysSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
